// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface MobilePhoneIconSignature {
  Element: SVGSVGElement;
}

export const MobilePhoneIcon: TOC<MobilePhoneIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.999 1.99902H15.999C17.102 1.99902 17.999 2.89602 17.999 3.99902V19.999C17.999 21.103 17.102 21.999 15.999 21.999H7.999C6.896 21.999 5.999 21.103 5.999 19.999V3.99902C5.999 2.89502 6.896 1.99902 7.999 1.99902ZM15.999 5.99902V3.99902H7.999V5.99902H15.999ZM16 7.99902V15.999H7.999V7.99902H16ZM7.999 17.999V19.999H16V17.999H7.999Z"/>
</svg>
</template>;